import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex justify-center py-2" };
const _hoisted_2 = ["aria-label"];
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageDateSeparator',
    props: {
        label: {},
        exactLabel: {}
    },
    setup(__props) {
        const exactVisible = ref(false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    type: "button",
                    class: "rounded-full border border-ewhite-200 bg-white px-3 py-1 text-xs font-medium text-eblack-500 shadow-sm transition hover:border-eorange-200 hover:text-eorange-600 focus:outline-none focus:ring-2 focus:ring-eorange-300",
                    "aria-label": exactVisible.value ? __props.exactLabel : `${__props.label}. ${__props.exactLabel}`,
                    onClick: _cache[0] || (_cache[0] = ($event) => (exactVisible.value = !exactVisible.value))
                }, _toDisplayString(exactVisible.value ? __props.exactLabel : __props.label), 9, _hoisted_2)
            ]));
        };
    }
});
